import { render, staticRenderFns } from "./infoEdit.vue?vue&type=template&id=86bff76c&scoped=true&"
import script from "./infoEdit.vue?vue&type=script&lang=js&"
export * from "./infoEdit.vue?vue&type=script&lang=js&"
import style0 from "./infoEdit.vue?vue&type=style&index=0&id=86bff76c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bff76c",
  null
  
)

export default component.exports